import { render, staticRenderFns } from "./xmHeader.vue?vue&type=template&id=48473b01&scoped=true&"
import script from "./xmHeader.vue?vue&type=script&lang=js&"
export * from "./xmHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48473b01",
  null
  
)

export default component.exports